import { createTheme } from '@mui/material';

export const customButtonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#FFF',
          backgroundColor: '#277134',
          borderRadius: '4px',
          padding: '12px 22px',
          fontSize: '15px',
          fontFamily: 'Rubik-Medium',
          boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.2)',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          transition: '0.1s',
          '&:hover': {
            backgroundColor: '#e69636',
          },
          '&:disabled': {
            cursor: 'not-allowed !important',
            backgroundColor: '#277134',
            pointerEvents: 'stroke',
          },
        },
      },
    },
  },
});

export const customFileButtonTheme = createTheme(customButtonTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          width: '200px',
          minWidth: '167px',
        },
      },
    },
  },
});

export const customInvertedButtonTheme = createTheme(customButtonTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#e69636',
          '&:hover': {
            backgroundColor: '#277134',
          },
        },
      },
    },
  },
});

export const customRedButtonTheme = createTheme(customButtonTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#d12d38',
          '&:hover': {
            backgroundColor: '#e69636',
          },
        },
      },
    },
  },
});

export const customToolbarButtonTheme = createTheme(customButtonTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: '45px',
          margin: 5,
          '& .brush_logo': {
            width: '28px !important',
            height: '28px !important',
            paddingLeft: '5px',
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '& .columnsPanelTrigger': {
            color: '#277134',
          },
          '& .columnsPanelTriggerText': {
            color: '#277134',
            fontSize: '13px',
            marginLeft: '8px',
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        toolbar: {
          justifyContent: 'start',
        },
      },
    },
  },
});
